<template>
    <div v-select-text="value" style="width: 800px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
        <table cellspacing="0" cellpadding="0" border="0" width="100%">
            <tbody>
            <tr>
                <td valign="top" width="250" style=" font-size: 18px; color: #36acff; font-weight:bold; padding-top: 40px; padding-right: 20px;">
                    <div style="padding: 4px;">Главная</div>
                    <div style="padding: 4px; border-top: 1px solid #efefef;">О нас</div>
                    <div style="padding: 4px; border-top: 1px solid #efefef;">Наши контакты</div>
                    <div style="padding: 4px; border-top: 1px solid #efefef;">Календарь</div>
                    <div style="padding: 4px; border-top: 1px solid #efefef;">События</div>

                    <div style="color: #a2d670; padding-top: 20px; margin-top: 20px; border-top: 1px solid #343434;">
                        <div style="padding: 4px;">По плану</div>
                        <div style="padding: 4px; border-top: 1px solid #efefef;">Награды</div>
                        <div style="padding: 4px; border-top: 1px solid #efefef;">Результаты</div>
                        <div style="padding: 4px; border-top: 1px solid #efefef; font-size: 15px;">Часто задаваемые вопросы</div>
                        <div style="padding: 4px; border-top: 1px solid #efefef;">Зарегистрироваться</div>
                    </div>
                </td>
                <td valign="top" style="font-size: 16px;">
                    <div class="title text-xs-center mb-4" style="color: #36acff;">ЧаВо (Часто задаваемые вопросы)</div>
                    <div style="padding: 14px 10px; background-color: #ececec; border-radius: 6px; margin-bottom: 20px;">
                        <strong>Как я могу зарегистрироваться?</strong><br>
                        <div>
                            Вы можете зарегистрироваться ОНЛАЙН через нашу безопасную онлайн-систему регистрации. Также вы можете зарегистрироваться на месте в день мероприятия.
                        </div>
                        <br>
                        <span style="color: blue; text-decoration: underline;">Для регистрации нажмите сюда.</span>
                    </div>

                    <div style="padding: 14px 10px; background-color: #ececec; border-radius: 6px; margin-bottom: 20px;">
                        <strong>Можно ли участвовать не только в «корэш», но и в беге на дистанцию и поднятии гирь?</strong><br>
                        <div>
                            Да, вы можете стать участником сразу нескольких состязаний, однако вам необходимо зарегистрироваться заранее, чтобы мы составили расписание. Напишите для этого нам на почту не позднее 10 июня: info@belyarochsa2017.ru
                        </div>
                    </div>

                    <div style="padding: 14px 10px; background-color: #ececec; border-radius: 6px; margin-bottom: 20px;">
                        <strong>Какие призы можно получить?</strong><br>
                        <div>
                            Призы за 1-е, 2-е и 3-е места будут вручены победителям в каждом из видом состязаний (призы разнятся от вида состязания)
                        </div>
                    </div>

                    <div style="padding: 14px 10px; background-color: #ececec; border-radius: 6px; margin-bottom: 20px;">
                        <strong>Разрешается ли приводить домашних животных?</strong><br>
                        <div>
                            Нет, мероприятие проходит в заповеднике, к тому же ожидается много людей.
                        </div>
                    </div>

                    <div style="padding: 14px 10px; background-color: #ececec; border-radius: 6px; margin-bottom: 20px;">
                        <strong>Если я хочу стать участником в «корэш», как мне нужно экипироваться?</strong><br>
                        <div>
                            Вам необходима удобная сменная обувь, шорты, футболка (возможно кимоно), наколенники. Пояса для борьбы вы получите на месте.
                        </div>
                    </div>

                    <div style="padding: 14px 10px; background-color: #ececec; border-radius: 6px; margin-bottom: 20px;">
                        <strong>Вручение комплекта экипировки</strong><br>
                        <div>
                            У каждого члена соревнований будет свой индивидуальный номер. Каждый должен будет забрать свой комплект при регистрации под собственным именем!
                        </div>
                    </div>

                    <div style="padding: 14px 10px; background-color: #ececec; border-radius: 6px; margin-bottom: 20px;">
                        <strong>Может ли кто-нибудь другой забрать мой комплект экипировки при регистрации?</strong><br>
                        <div>
                            Да. Этот человек должен будет вписать ваше имя при регистрации и забрать ваш комплект.
                        </div>
                    </div>

                    <div style="padding: 14px 10px; background-color: #ececec; border-radius: 6px; margin-bottom: 20px;">
                        <strong>С кем мне связаться, если я захочу поделиться своим мнением о мероприятии?</strong><br>
                        <div>
                            Все электронные письма с откликами следует отправлять по адресу: info@belyarochsa2017.ru
                        </div>
                    </div>

                    <div style="padding: 14px 10px; background-color: #ececec; border-radius: 6px; margin-bottom: 20px;">
                        <strong>Куда будут направлены вырученные средства c продажи еды и добровольные пожертвования?</strong><br>
                        <div>
                            Вырученная сумма пойдет на реализацию местных проектов по охране окружающей среды.
                        </div>
                    </div>

                    <div class="mt-4" style="font-weight:bold; color: blue; text-decoration: underline;">Зарегистрируйтесь онлайн сегодня!</div>

                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>
<style scoped></style>